import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_admin/user-roles')({
  staticData: {
    title: 'pages.userRoles.title',
    description: 'pages.userRoles.description',
  },
  component: UserRolesPage,
});

function UserRolesPage() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">User Roles</h1>
        <p className="mt-2 text-gray-600">
          Admin: Manage user roles and permissions
        </p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          User Roles Management
        </h2>
        <p className="text-gray-600">
          This page will allow administrators to manage user roles, permissions,
          and access levels.
        </p>
      </div>
    </div>
  );
}
